export enum MuscularStrengthValueKinds {
  /**
   * ×、△、〇
   */
  Symbol = 1,
  /**
   * ×、△、4、5
   */
  SymbolAndNumber = 2,
  /**
   * 0、1、2、3、4、5
   */
  Number = 3,
}
